import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_hindu-service-hub/artifacts/wgibtr2f_Dharma%20Astra%20-%20Original%20%282%29.png";

const Footer = () => {
  return (
    <footer className="bg-terracotta text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Dharma Astra Association" 
                className="w-14 h-14 object-contain bg-white rounded-full p-1"
              />
              <div>
                <h3 className="font-heading text-xl font-bold">Dharma Astra</h3>
                <p className="text-xs text-white/70 font-body">Association</p>
              </div>
            </div>
            <p className="text-white/80 font-body text-sm leading-relaxed">
              Preserving Dharma through temple construction, cultural preservation, and social welfare activities across India.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="YouTube">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3 font-body text-sm">
              <li><Link to="/about" className="text-white/80 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/causes" className="text-white/80 hover:text-white transition-colors">Our Causes</Link></li>
              <li><Link to="/donate" className="text-white/80 hover:text-white transition-colors">Donate</Link></li>
              <li><Link to="/volunteer" className="text-white/80 hover:text-white transition-colors">Volunteer</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Legal</h4>
            <ul className="space-y-3 font-body text-sm">
              <li><Link to="/privacy-policy" className="text-white/80 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="text-white/80 hover:text-white transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy" className="text-white/80 hover:text-white transition-colors">Refund Policy</Link></li>
              <li><Link to="/donor-data-policy" className="text-white/80 hover:text-white transition-colors">Donor Data Policy</Link></li>
              <li><Link to="/volunteer-terms" className="text-white/80 hover:text-white transition-colors">Volunteer Terms</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4 font-body text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 mt-0.5 text-saffron" />
                <span className="text-white/80">Hyderabad, Telangana, India</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-saffron" />
                <a href="tel:+918977116677" className="text-white/80 hover:text-white transition-colors">+91 8977116677</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-saffron" />
                <a href="mailto:support@dharma-astra.org" className="text-white/80 hover:text-white transition-colors">support@dharma-astra.org</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm font-body text-center md:text-left">
              © {new Date().getFullYear()} Dharma Astra Association. All rights reserved.
            </p>
            <p className="text-white/60 text-sm font-body">
              For a Better Society
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
